"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetch = fetch;

var _ImmutableAPI = require("crm_data/api/ImmutableAPI");

var _immutable = require("immutable");

var URI = 'campaigns/v1/campaigns/guids';

function fetch(campaignIds) {
  var query = {
    guid: campaignIds.toJS(),
    includeDeletes: true
  };
  return (0, _ImmutableAPI.get)(URI, query).then(function (results) {
    return results.reduce(function (campaigns, campaign) {
      return campaigns.set(campaign.get('guid'), campaign);
    }, (0, _immutable.Map)());
  });
}